import * as React from 'react';
import BetsForMatchesTable from '../BetsForMatchesTable';
import MatchVarietyDto from '../../models/dtos/MatchVarietyDto';

export default function MatchBetsTab(props: { matchId: number; varieties: MatchVarietyDto[] }) {
    return <BetsForMatchesTable matchId={props.matchId} varieties={props.varieties} />;
}
